export default __webpack_public_path__ + "static/media/pressonsecurenetwork.166db23d.png";